import { render, staticRenderFns } from "./combo-boost-promotion.vue?vue&type=template&id=db51d3d8&"
import script from "./combo-boost-promotion.vue?vue&type=script&lang=js&"
export * from "./combo-boost-promotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports